<template>
  <transition name="fade" appear>
    <div
      class="modal-overlay bg-white opacity-50 min-h-[100vh] max-w-[100vw] absolute left-0 right-0 bottom-0 top-0"
      v-show="showModal" @click.prevent="close()"></div>
  </transition>
  <transition name="pop" appear>
    <div class="modal absolute top-[70px] left-[50%] transform -translate-x-1/2 z-[99]" v-show="showModal"
      id="roadmap-page-block" role="dialog">
      <div id="login-dialog"
        class="dialog border border-[#E2E8F0] rounded-[8px] p-[20px] max-w-[670px] min-w-[670px] min-h-[460px] max-h-fit-content m-auto bg-white overflow-hidden text-center overflow-visible">
        <div>
          <div class="!relative overflow-hidden px-[40px] py-[30px]">
            <div @click="close"
              class="cursor-pointer close__btn absolute bg-[#ECF0FA] w-[32px] h-[32px] flex justify-center items-center rounded-[18px] right-[15px] top-[15px]">
            </div>
          </div>
          <div
            class="modal-body text-center flex flex-col max-w-full mx-auto text-left text-[#333] pt-0 m-0">
            <TitleComponent text="Login to your account"
              class="body__title font-montserrat-semibold text-[38px] leading-[45px] text-vip-black px-[96px] mb-[35px]" />

            <form @submit.prevent="validateForm">
              <input
                placeholder="Enter username"
                type="text"
                v-model="credentials.username"
                autocomplete="username"
                class="w-full border border-[#E2E8F0] rounded-[8px] py-[10px] px-[12px] mt-[20px]"
              />
              <span v-if="errors.username" class="text-red text-sm block text-left">{{ errors.username }}</span>

              <input
                placeholder="Password"
                type="password"
                v-model="credentials.password"
                autocomplete="current-password"
                class="w-full border border-[#E2E8F0] rounded-[8px] py-[10px] px-[12px] mt-[20px]"
              />
              <span v-if="errors.password" class="text-red text-sm block text-left">{{ errors.password }}</span>

              <button
                type="submit"
                class="flex gap-[20px] items-center block mx-auto justify-center hover:!bg-[#000000] my-[40px] focus:!bg-[#000000] capitalize !bg-[#2B2B2B] text-white !min-h-[50px] !max-h-[60px] !w-[210px] button text-white font-montserrat-bold bg-blue-light text-[16px] font-bold rounded-[10px]"
              >
                Sign in
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { setToStorage as setToLocalStorage, getFromStorage as getFromLocalStorage } from '@/helpers/localStorage';

import TitleComponent from '@/components/common/TitleComponent.vue';
import api from '@/helpers/api';

export default {
  emits: ['close'],
  name: 'LoginModal',
  components: {
    TitleComponent,
  },
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      credentials: {
        username: '',
        password: '',
      },
      errors: {
        username: '',
        password: '',
      },
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  mounted() {
   //
  },
  methods: {
    validateForm() {
      // Reset errors
      this.errors = {
        username: '',
        password: '',
      };

      // Validate username
      if (!this.credentials.username) {
        this.errors.username = 'Username is required.';
      }

      // Validate password
      if (!this.credentials.password) {
        this.errors.password = 'Password is required.';
      } 
      // else if (this.credentials.password.length < 6) {
      //   this.errors.password = 'Password must be at least 6 characters long.';
      // }

      // If no errors, proceed with login
      if (!this.errors.username && !this.errors.password) {
        this.login();
      }
    },
    login() {
      // Logic for login goes here
      console.log('Login button clicked');
      api.login(this.credentials.username, this.credentials.password)
        .then((response) => {
          console.log('Login successful:', response);
          const result = response.data.result;
          console.log('Login result:', result);
         
          this.handleLoginSuccess(result);
        })
        .catch((error) => {
          console.error('Login failed:', error);
          // Handle login error (e.g., show an error message)
          this.errors.username = 'Invalid username or password.';
        });   
    },
    handleLoginSuccess(result) {
      console.log('Handling login success:', result);
      setToLocalStorage('token', result.access);
      setToLocalStorage('refreshToken', result.refresh);
      this.$store.commit('SET_IS_LOGGED_IN', true);
      this.close();
    },
    close() {
      setTimeout(() => {
        this.$emit('close');
      }, 100);
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Jost-Regular', sans-serif;
}
@media (max-width: 900px) {
  #login-dialog {
    max-width: 750px;
    min-width: 750px;
    height: 276px;
  }
}
@media (max-width: 790px) {
  #login-dialog  {
    max-width: 650px;
    min-width: 650px;
    height: 276px;
    gap: 20px;
    grid-template-columns: 1fr 3fr;
  }
  #login-dialog .image__container {
    width: 280px;
  }
  #login-dialog .close__btn {
    right: 30px;
  }
}
@media (max-width: 680px) {
  #login-dialog {
    max-width: 90vw !important;
    min-width: 90vw !important;
    margin: auto;
    height: fit-content;
  }
  .body__title {
    font-size: 40px;
    line-height: 35px;
    padding: 0;
    margin: 20px 0; 
  }
}
@media (max-width: 540px) {
  #login-dialog {
    max-width: 90vw !important;
    min-width: 90vw !important;
    margin: 0 auto !important;
    height: fit-content;
  }
  .body__title {
    font-size: 40px;
    line-height: 35px;
    padding: 0;
    margin-bottom: 20px;
  }
}
</style>
